export default __webpack_public_path__ + "static/media/footerAdvanced.31336a96.png";